module.exports = __webpack_public_path__ + "images/62a1a4ec2d237e7d2b0beadae26d083d-profile_overlay.jpg";